import React, { useEffect, useState } from "react";
import Eligibility from "./Eligibility/Index";
import Estimator from "./Estimator/Index";
import Tailor from "./Tailor/Index";
import Insights from "./Insights/Index";
import { useLocation } from "react-router-dom";

const Index = () => {
  const [pageType, setPageType] = useState();
  const location = useLocation();
  // console.log(location.pathname, "pathname");
  const pathname = location.pathname;

  useEffect(() => {
    if (pathname === "/personal-loan/check-eligibility/loan-eligibility") {
      setPageType("pl");
    } else {
      setPageType("cl");
    }
  }, [pathname]);

  return (
    <>
      <Eligibility pageType={pageType} />
      <Estimator pageType={pageType} />
      <Tailor pageType={pageType} />
      <Insights pageType={pageType} />
      {/* <Footer /> */}
    </>
  );
};

export default Index;
